$(document).ready(function() {

    // Tab Append
    $('.appendtabfea').appendTo('#tab-fea-0');
    $('.appendtablatest').appendTo('#tab-latest-0');
    $('.appendtabbest').appendTo('#tab-best-0');
  
    // Slideshow
    $('.owl-slider').slick({
        dots: true,
        arrows: false,
        infinite: false,
        autoplay: false,
        autoplaySpeed: 2000,
        slidesToShow: 1,
        slidesToScroll: 1
    });

    // top category
    $('.owl-catt').slick({
        dots: false,
        arrows: true,
        infinite: false,
        autoplay: false,
        autoplaySpeed: 2000,
        slidesToShow: 7,
        slidesToScroll: 1,
        responsive: [
        {
            breakpoint: 1410,
            settings: {
                slidesToShow: 5
            }
        },
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 4
            }
        },
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 3
            }
        },
        {
            breakpoint: 576,
            settings: {
                slidesToShow: 2
            }
        } 
        ]
    });
    $(".owl-catt").show();

    // The new tab behavior is opt-in; other pages retain their existing behavior.
    if (document.querySelector('[data-aura-product-tabs]')) {
    // One section owns its tabs; initialize only visible sliders.
    function syncProductTabs(root) {
        $(root).find('[data-aura-product-tabs]').addBack('[data-aura-product-tabs]').find('[role="tabpanel"]').each(function () {
            var slider = $(this).find('.owl-toppro');
            var useSlider = window.innerWidth <= 1591 || slider.hasClass('aura-top-compact');
            if (!useSlider && slider.hasClass('slick-initialized')) slider.slick('unslick');
            if (this.hidden) return;
            if (useSlider && !slider.hasClass('slick-initialized') && $.fn.slick) {
                slider.slick({
                    dots: false, arrows: true, infinite: false, autoplay: false,
                    slidesToShow: 4, slidesToScroll: 1,
                    responsive: [
                        {breakpoint: 1400, settings: {slidesToShow: 3}},
                        {breakpoint: 992, settings: {slidesToShow: 2}},
                        {breakpoint: 361, settings: {slidesToShow: 1}}
                    ]
                });
            } else if (useSlider && slider.hasClass('slick-initialized')) {
                slider.slick('setPosition');
            }
        });
    }
    function selectProductTab(tab, focus) {
        var section = tab.closest('[data-aura-product-tabs]');
        section.querySelectorAll('[role="tab"]').forEach(function (item) {
            var active = item === tab;
            item.setAttribute('aria-selected', String(active));
            item.tabIndex = active ? 0 : -1;
            item.parentElement.classList.toggle('active', active);
            var panel = document.getElementById(item.getAttribute('aria-controls'));
            if (panel && section.contains(panel)) {
                panel.hidden = !active;
                panel.classList.toggle('active', active);
                panel.classList.toggle('show', active);
            }
        });
        syncProductTabs(section);
        if (focus) tab.focus({preventScroll: true});
    }
    $(document).on('click.auraProductTabs keydown.auraProductTabs', '[data-aura-product-tabs] [role="tab"]', function (event) {
        if (event.type === 'click' || event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            selectProductTab(this, false);
            return;
        }
        var tabs = Array.from(this.closest('[role="tablist"]').querySelectorAll('[role="tab"]'));
        var index = tabs.indexOf(this);
        if (event.key === 'ArrowRight') index = (index + 1) % tabs.length;
        else if (event.key === 'ArrowLeft') index = (index + tabs.length - 1) % tabs.length;
        else if (event.key === 'Home') index = 0;
        else if (event.key === 'End') index = tabs.length - 1;
        else return;
        event.preventDefault();
        selectProductTab(tabs[index], true);
    });
    syncProductTabs(document);
    var productTabResize;
    $(window).on('resize.auraProductTabs', function () {
        window.clearTimeout(productTabResize);
        productTabResize = window.setTimeout(function () { syncProductTabs(document); }, 120);
    });
    document.addEventListener('shopify:section:load', function (event) { syncProductTabs(event.target); });
    document.addEventListener('shopify:section:reorder', function (event) { syncProductTabs(event.target); });
    document.addEventListener('shopify:section:unload', function (event) {
        $(event.target).find('.owl-toppro.slick-initialized').slick('unslick');
    });
    } else {
        if ($(window).width() <= 1591) {
            $('.owl-toppro').slick({
                dots: false, arrows: true, infinite: false, autoplay: false,
                autoplaySpeed: 2000, slidesToShow: 4, slidesToScroll: 1,
                responsive: [
                    {breakpoint: 1400, settings: {slidesToShow: 3}},
                    {breakpoint: 992, settings: {slidesToShow: 2}},
                    {breakpoint: 576, settings: {slidesToShow: 2}},
                    {breakpoint: 361, settings: {slidesToShow: 1}}
                ]
            });
        }
        $('.owl-toppro').show();
    }

    // Home Tab Product   
    var homeGridSliderOptions = {
        dots: false,
        arrows: true,
        infinite: false,
        autoplay: false,
        autoplaySpeed: 2000,
        slidesToShow: 5,
        slidesToScroll: 1,
        responsive: [
        {
            breakpoint: 1400,
            settings: {
                slidesToShow: 3
            }
        },
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 2
            }
        },
        {
            breakpoint: 576,
            settings: {
                slidesToShow: 2
            }
        },
        {
            breakpoint: 361,
            settings: {
                slidesToShow: 1
            }
        }
        ]
    };
    $('.wbtopr,.wbnewpro,.wbsale').slick(homeGridSliderOptions);
    $(".wbtopr").show();
    $(".wbnewpro").show();
    $(".wbsale").show();

    // Latest Product
    var homeListSliderOptions = {
        dots: false,
        arrows: true,
        infinite: false,
        autoplay: false,
        autoplaySpeed: 2000,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
        {
            breakpoint: 1400,
            settings: {
                slidesToShow: 2
            }
        },
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 1
            }
        },
        {
            breakpoint: 576,
            settings: {
                slidesToShow: 1
            }
        },
        {
            breakpoint: 361,
            settings: {
                slidesToShow: 1
            }
        }
        ]
    };
    $('.wblatest').slick(homeListSliderOptions);
    $(".wblatest").show();

    // Home Left Product   
    var sidebarProductSliderOptions = {
        dots: false, 
        arrows: true, 
        infinite: false, 
        autoplay: false, 
        autoplaySpeed: 2000, 
        slidesToShow: 1, 
        slidesToScroll: 1, 
        responsive: [
        {
            breakpoint: 1400,
            settings: { 
                slidesToShow: 1 
            }
        },
        {
            breakpoint: 768,
            settings: { 
                slidesToShow: 2  
            }
        },
        {  
            breakpoint: 576, 
            settings: {  
                slidesToShow: 1 
            }
        }
        ]  
    };
    $('.wbpop,.wbbestp').slick(sidebarProductSliderOptions);
    $(".wbpop,.wbbestp").show();

    // Reuse the same sliders after an OS 2.0 editor section refresh.
    if (window.Shopify && Shopify.designMode) {
        document.addEventListener('shopify:section:load', function (event) {
            var section = $(event.target);
            section.find('.wbtopr,.wbnewpro,.wbsale').not('.slick-initialized').slick(homeGridSliderOptions).show();
            section.find('.wblatest').not('.slick-initialized').slick(homeListSliderOptions).show();
            section.find('.wbpop,.wbbestp').not('.slick-initialized').slick(sidebarProductSliderOptions).show();
        });
    }

    // special product
    $('.wbspeprod').slick({
        dots: false,
        arrows: true,
        infinite: false,
        autoplay: false,
        autoplaySpeed: 2000,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 1
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 575,
                settings: {
                    slidesToShow: 1
                }
            }
        ]

    });
    $(".wbspeprod").show();


    // Countdown Timer
    $('[data-countdown]').each(function() {
        var $this = $(this), finalDate = $(this).data('countdown');
        Date.prototype.yyyymmdd = function() {
            var yyyy = this.getFullYear().toString();
            var mm = (this.getMonth()+1).toString(); // getMonth() is zero-based
            var dd  = this.getDate().toString();
            return yyyy + "/" + (mm[1]?mm:"0"+mm[0]) + "/" + (dd[1]?dd:"0"+dd[0]); // padding
        };
        var date = new Date();
        if (finalDate > date.yyyymmdd()){
            $(this).parents('.timer_outer').css('display','block');
        }else{
            $(this).parents('.timer_outer').css('display','none');  
        }
        $this.countdown(finalDate, function(event) {
            $this.html(event.strftime('<div><span>%D</span><strong>Days</strong></div><div><span>%H</span><strong>Hours</strong></div><div><span>%M</span><strong>Min</strong></div><div><span>%S</span><strong>Sec</strong></div>'));
        });
    });



    // Testimonial
    $('.testi').slick({
        dots: true,
        arrows: false,
        infinite: false,
        autoplay: false,
        autoplaySpeed: 2000,
        slidesToShow: 1,
        slidesToScroll: 1
    });
  	$(".testi").show();


    // Blog
    $('.wbblog').slick({
        dots: false,
        arrows: true,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 2000,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 2
            }
        },
        {
            breakpoint: 576,
            settings: {
                slidesToShow: 1
            }
        }
        ]
    });
  	$(".wbblog").show();

    // Logo Slider
    $('.wblogobar').slick({
        dots: false,
        arrows: false,
        infinite: false,
        autoplay: true,
        autoplaySpeed: 3000,
        slidesToShow: 8,
        slidesToScroll: 1,
        responsive: [
        {
            breakpoint: 1410,
            settings: {
                slidesToShow: 7
            }
        },
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 5
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 4
            }
        },
        {
            breakpoint: 576,
            settings: {
                slidesToShow: 3
            }
        }
        ]
    });
  	$(".wblogobar").show();
  
    // Keep the live theme's legacy tabs on pages without the new homepage tabs.
    if (!document.querySelector('[data-aura-product-tabs]')) {
        $('.nav-tabs .nav-item.active').click();
        $(document).on('click', '.nav-tabs .nav-item', function(e) {
            e.preventDefault();
            $('.nav-tabs .nav-item').removeClass('active');
            $(this).addClass('active');
            let tid = $(this).find('a').attr('href');
            $('.tab-pane').removeClass('active show');
            $(tid).addClass('active show');
        });
    }

    // header menu more
    if ($(document).width() >= 1410){
         var count_block = $('#wbmegalevel-1 .wbmenul_1').length;
         var number_blocks = 10;
         if(count_block >= number_blocks){
              
              $('#wbmegalevel-1 .wbmenul_1').each(function(i,n){
                    if(i == number_blocks) {
                         $('#wbmegalevel-1').append('<li class="view_more wbmenul_1"><i class="fa fa-plus"></i><a class="dropdown-item wbmenul1_link">More</a></li>');
                    }
                    if(i> number_blocks) {
                         $(this).addClass('wr_hide_menu');
                    }
              })
              $('.wr_hide_menu').hide();
              $('.view_more.wbmenul_1').click(function() {
                    $(this).toggleClass('active');
                    $('.wr_hide_menu').slideToggle();
              });
         }
    }

    if (($(document).width() >= 768) && ($(document).width() <= 1199)) {
         var count_block = $('#wbmegalevel-1 .wbmenul_1').length;
         var number_blocks = 6;
         if(count_block >= number_blocks){
              
              $('#wbmegalevel-1 .wbmenul_1').each(function(i,n){
                    if(i == number_blocks) {
                         $('#wbmegalevel-1').append('<li class="view_more wbmenul_1"><i class="fa fa-plus"></i><a class="dropdown-item wbmenul1_link">More</a></li>');
                    }
                    if(i> number_blocks) {
                         $(this).addClass('wr_hide_menu');
                    }
              })
              $('.wr_hide_menu').hide();
              $('.view_more.wbmenul_1').click(function() {
                    $(this).toggleClass('active');
                    $('.wr_hide_menu').slideToggle();
              });
         }
    }

    // Scroll To top
    $("#scroll").addClass("scrollhide");
        $(window).scroll(function () {
        if ($(this).scrollTop() === 0) {
            $("#scroll").addClass("scrollhide")
        } else {
            $("#scroll").removeClass("scrollhide")
        }
    });
    $('#scroll').click(function () {
        $("html, body").animate({scrollTop: 0}, 600);
        return false;
    });

    // Mobile Menu Toggle
    (function setupMegamenuPlacement() {
        var megamenu = document.getElementById('megamenu');
        var headlogo = document.querySelector('.headlogo');
        if (!megamenu || !headlogo) return;

        var menuPlaceholder = document.createComment('megamenu-placement');
        var originalParent = megamenu.parentNode;
        originalParent.insertBefore(menuPlaceholder, megamenu);
        var quickLinks = document.querySelector('#shopify-section-cms-menu .cms-menu__scroll');
        var quickLinksPlaceholder = null;
        var mobileMainNav = null;
        var menuList = megamenu.querySelector('.menu-vertical');
        if (quickLinks && menuList) {
            quickLinksPlaceholder = document.createComment('cms-menu-placement');
            quickLinks.parentNode.insertBefore(quickLinksPlaceholder, quickLinks);
            mobileMainNav = document.createElement('li');
            mobileMainNav.className = 'fine-art-mobile-main-nav';
            mobileMainNav.setAttribute('role', 'group');
            mobileMainNav.setAttribute('aria-label', 'Store navigation');
            document.documentElement.classList.add('fine-art-drawer-nav-ready');
        }
        var wasMobile = null;

        function isMobileMenu() {
            // ponytail: keep the placement threshold aligned with the theme's 991px breakpoint.
            return window.innerWidth <= 991;
        }

        function resetMobileSubmenus() {
            $(megamenu).find('.wbmegamainhd').removeClass('active');
            $(megamenu).find('.wbmenudropdown, .droped_linklist').each(function() {
                this.style.display = '';
            });
        }

        function syncMegamenuPlacement() {
            var isMobile = isMobileMenu();
            if (isMobile === wasMobile) return;

            if (!isMobile && megamenu.classList.contains('active')) {
                w3_close();
            }

            resetMobileSubmenus();
            if (isMobile) {
                if (megamenu.parentNode !== headlogo) {
                    headlogo.insertBefore(megamenu, headlogo.firstChild);
                }
                if (mobileMainNav && quickLinks && menuList) {
                    var subjectHeading = menuList.querySelector('.fine-art-mobile-subject-heading');
                    menuList.insertBefore(mobileMainNav, subjectHeading || menuList.children[1] || null);
                    mobileMainNav.appendChild(quickLinks);
                }
            } else if (menuPlaceholder.parentNode) {
                menuPlaceholder.parentNode.insertBefore(megamenu, menuPlaceholder.nextSibling);
                if (quickLinksPlaceholder && quickLinksPlaceholder.parentNode && quickLinks) {
                    quickLinksPlaceholder.parentNode.insertBefore(quickLinks, quickLinksPlaceholder.nextSibling);
                }
                if (mobileMainNav && mobileMainNav.parentNode) {
                    mobileMainNav.parentNode.removeChild(mobileMainNav);
                }
            }

            wasMobile = isMobile;
        }

        $(document)
            .off('click.fineArtMobileMenu', '#megamenu .wbmegamainhd')
            .on('click.fineArtMobileMenu', '#megamenu .wbmegamainhd', function(event) {
                if (!isMobileMenu()) return;

                event.preventDefault();
                var targetMenu = document.getElementById($(this).data('submenu'));
                if (!targetMenu) return;

                var willExpand = !$(this).hasClass('active');
                $(targetMenu).stop(true, false).slideToggle(220);
                $(this).toggleClass('active', willExpand).attr('aria-expanded', String(willExpand));
            });

        $(document)
            .off('keydown.fineArtMobileMenu')
            .on('keydown.fineArtMobileMenu', function(event) {
                if (!megamenu.classList.contains('active')) return;

                if (event.key === 'Tab') {
                    var focusable = Array.prototype.filter.call(
                        megamenu.querySelectorAll('.menu-vertical a[href], .menu-vertical button:not([disabled])'),
                        function(element) {
                            var rect = element.getBoundingClientRect();
                            var styles = window.getComputedStyle(element);
                            return rect.width > 0 && rect.height > 0 && styles.visibility !== 'hidden' && styles.display !== 'none';
                        }
                    );
                    if (!focusable.length) return;

                    var firstFocusable = focusable[0];
                    var lastFocusable = focusable[focusable.length - 1];
                    if (!megamenu.contains(document.activeElement)) {
                        event.preventDefault();
                        (event.shiftKey ? lastFocusable : firstFocusable).focus({preventScroll: true});
                    } else if (event.shiftKey && document.activeElement === firstFocusable) {
                        event.preventDefault();
                        lastFocusable.focus({preventScroll: true});
                    } else if (!event.shiftKey && document.activeElement === lastFocusable) {
                        event.preventDefault();
                        firstFocusable.focus({preventScroll: true});
                    }
                    return;
                }

                if (event.key === 'Escape' || event.key === 'Esc') {
                    event.preventDefault();
                    w3_close();
                }
            });

        syncMegamenuPlacement();
        window.addEventListener('resize', syncMegamenuPlacement);
    })();

    if ($(window).width() <= 767) {
//         $('.leftw').appendTo('.right-col');
        $('.headtleft localization-form').appendTo('.customer_account ul');
        $('.wbheadwish').appendTo('.customer_account ul .wbhwish');
        
    };

    // Collection Grid/List View
    $(document).on('click', '.wblistgridbtn', function(e) {
        $(this).addClass('active').siblings().removeClass('active');
        if ($(this).hasClass('listv')) {
            $('#product-grid').addClass('product-list').removeClass('product-grid');
        } else if ($(this).hasClass('gridv')) {
            $('#product-grid').addClass('product-grid').removeClass('product-list');
        }
    });

    

    // Popup Product
    $('.wbpopup-popducts .popinner').hide();
    var i = 0;
    setIntervalFun();
    var totalTimer = parseInt(3000) + parseInt(2000);
    setInterval( setIntervalFun, totalTimer);
    function setIntervalFun()
    {
        $('.wbpopup-popducts .popinner').eq(i).fadeIn(400);
        setTimeout(function(){
            $('.wbpopup-popducts .popinner').eq(i).fadeOut(400);
            i++;
            if ($('.wbpopup-popducts .popinner').length <= i) {
                i = 0;
            }
        },parseInt(7000));
    }
    $(document).on('click', '.wbclosepopup', function(){
        $('.wbpopup-popducts').fadeOut(400).remove();
    });

    // Box Layout
    $(".wbboxdemo").click(function(){
        $(".wbboxlt").attr("id","wbboxlayout");
    });
    $(".wbwidedemo").click(function(){
        $(".wbboxlt").removeAttr("id");
    }); 
    // Color Customizer
    $("body").on("click", ".wbinnerclr a", function(e){
    e.preventDefault();
    $('.wbinnerclr').find(".active").removeClass("active");
    $(this).parent().addClass("active");
    $('[wbcolorname=""]').remove();
    if(!$(this).hasClass($('html').attr(''))) $("body").append('<link rel="stylesheet" type="text/css" wbcolorname href="' + $(this).attr('href') + '">');
    });
    // Rtl Mode
    $("body").on("click", ".wbrtlmode a", function(e){ 
    e.preventDefault();
    $('.wbrtlmode').find(".active").removeClass("active");
    $(this).parent().addClass("active");
    $('[wbrtl=""]').remove();
    if(!$(this).hasClass($('html').attr(''))) $("body").append('<link rel="stylesheet" type="text/css" wbrtl href="' + $(this).attr('href') + '">');
    });
    // Color Open/Close 
    $('.wbopen-closeclr').click(function() {
        if ($(this).hasClass('wbclrdisable')) {
            $(this).removeClass('wbclrdisable');
            $(this).addClass('wbclrenable');
            $('.wbcolor_box').animate({right: '30px'}, 450);
            $('.wbcolor_box').css({'box-shadow': '0 10px 35px 10px rgba(0,0,0,.06)', 'background': '#fff', 'border-radius': '4px 0 4px 4px'});
            $('.wbcolor_option,.wbcolor_title').animate({'opacity': '1'}, 450);
        } else {
            $(this).removeClass('wbclrenable');
            $(this).addClass('wbclrdisable');
            $('.wbcolor_box').animate({right: '-250px'}, 450);
            $('.wbcolor_box').css({'box-shadow': 'none', 'background': 'transparent'});
            $('.wbcolor_option,.wbcolor_title').animate({'opacity': '0'}, 450);
        }
    });


}); // Document Ready Div End


// $(window).on('load',function(){
//     $("body.loader").removeClass("wrloader");
// });

// Menu For Mobile
var w3MenuTrigger = null;
var w3ScrollY = null;
function w3_prepare_open(event) {
    var megamenu = document.getElementById("megamenu");
    if (!megamenu || megamenu.classList.contains('active')) return;

    // Preserve the long-page position before a pointer interaction can focus
    // the header button and pull the viewport upward.
    w3ScrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
}
function w3_open() {
    var overlay = document.getElementById("myOverlay");
    var megamenu = document.getElementById("megamenu");
    if (!megamenu) return;
    if (megamenu.classList.contains('active')) {
        var activeCloseButton = megamenu.querySelector('.closebtn');
        if (activeCloseButton) activeCloseButton.focus({preventScroll: true});
        return;
    }

    w3MenuTrigger = megamenu.querySelector('.wr-menu');
    if (w3ScrollY === null) {
        w3ScrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    }
    if (overlay) {
        overlay.style.display = "block";
        overlay.setAttribute('aria-hidden', 'false');
    }
    megamenu.classList.add("active");
    if (w3MenuTrigger) w3MenuTrigger.setAttribute('aria-expanded', 'true');
    $('body').addClass("wbbodyscroll");
    var closeButton = megamenu.querySelector('.closebtn');
    if (closeButton) {
        var focusCloseButton = function() {
            if (megamenu.classList.contains('active')) closeButton.focus({preventScroll: true});
        };
        focusCloseButton();
        window.requestAnimationFrame(focusCloseButton);
    }
    var openScrollY = w3ScrollY;
    if (openScrollY !== null) {
        window.requestAnimationFrame(function() {
            if (megamenu.classList.contains('active')) window.scrollTo(0, openScrollY);
        });
    }
}
function w3_close() {
    var overlay = document.getElementById("myOverlay");
    var megamenu = document.getElementById("megamenu");
    if (!megamenu) return;

    var wasOpen = megamenu.classList.contains('active');
    var trigger = w3MenuTrigger || megamenu.querySelector('.wr-menu');
    var restoreScrollY = w3ScrollY;
    if (overlay) {
        overlay.style.display = "none";
        overlay.setAttribute('aria-hidden', 'true');
    }
    megamenu.classList.remove("active");
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    $('body').removeClass("wbbodyscroll");
    if (wasOpen && trigger) trigger.focus({preventScroll: true});
    if (restoreScrollY !== null) {
        var restoreScrollPosition = function() {
            window.scrollTo(0, restoreScrollY);
        };
        restoreScrollPosition();
        window.requestAnimationFrame(function() {
            restoreScrollPosition();
        });
        window.setTimeout(restoreScrollPosition, 0);
    }
    w3ScrollY = null;
    w3MenuTrigger = null;
}
